export const LANGUAGE = {
    ENGLISH: { label: 'LANG_EN', value: 0, sortLabel: 'en' },
    JAPAN: { label: 'LANG_JP', value: 1, sortLabel: 'jp' },
};
